import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation5({ animation, badge, all_animations }: Props) {
  const [displayedPoints, setDisplayedPoints] = useState(0)
  const [isRolling, setIsRolling] = useState(true)
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 300)

    // Animation de compteur
    const duration = 2000
    const steps = 30
    const stepDuration = duration / steps
    let currentStep = 0

    const interval = setInterval(() => {
      currentStep++
      const progress = currentStep / steps
      const easedProgress = 1 - Math.pow(1 - progress, 3)
      setDisplayedPoints(Math.floor(easedProgress * badge.points_awarded))

      if (currentStep >= steps) {
        clearInterval(interval)
        setDisplayedPoints(badge.points_awarded)
        setIsRolling(false)
      }
    }, stepDuration)

    return () => clearInterval(interval)
  }, [badge.points_awarded])

  const digits = displayedPoints.toString().padStart(3, '0').split('')

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes slotMachine {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        .slot-digit {
          animation: slotMachine 0.1s ease-in-out infinite;
        }
        .slot-digit.stopped {
          animation: none;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Badge */}
        <div className={`transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="w-32 h-32 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/30 mb-4">
            <span className="text-6xl">{badge.emoji}</span>
          </div>
          <div className="text-2xl font-bold text-tessan-cream text-center mb-4">{badge.name}</div>
        </div>

        {/* Compteur style casino */}
        <div className="flex gap-2 bg-tessan-green-hover/50 p-4 rounded-2xl border-4 border-tessan-yellow shadow-2xl shadow-tessan-yellow/30">
          <span className="text-3xl text-tessan-yellow font-bold mr-2">+</span>
          {digits.map((digit, index) => (
            <div
              key={index}
              className={`w-16 h-24 bg-tessan-green rounded-lg flex items-center justify-center border-2 border-tessan-yellow/50 ${isRolling ? 'slot-digit' : 'slot-digit stopped'}`}
            >
              <span className="text-5xl font-mono font-black text-tessan-yellow">
                {digit}
              </span>
            </div>
          ))}
          <span className="text-xl sm:text-2xl text-tessan-cream font-semibold ml-2 self-center">pts</span>
        </div>

        {/* Message de victoire */}
        <div className={`mt-6 transition-all duration-500 ${!isRolling ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}`}>
          <div className="text-2xl text-tessan-yellow font-bold animate-bounce">
            Badge débloqué !
          </div>
        </div>
      </div>
    </AnimationLayout>
  )
}
